<template>
  <div class="container pt-5">
    <div class="row">
      <div class="text-center w-100 align-middle">
        <h2 class="title text-danger">404 Not Found</h2>
        <h2 class="title">Oops! It seems that this page does not exist.</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage'
}
</script>

<style scoped></style>
